<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <agencia-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import AgenciaCrud from "./AgenciaCrud";
    export default {
        name: "Agencia",
        components: {AgenciaCrud}
    }
</script>

<style scoped>

</style>

